import { sum } from 'lib/array/arrayUtils'

export function getSelectedTransferExtras(
  extras: Array<App.ExperienceTransferSelectedExtra> | undefined,
): Array<App.ExperienceTransferSelectedExtra> | undefined {
  const selectedExtras = extras?.filter(extra => extra.quantity > 0)

  return selectedExtras?.length ? selectedExtras : undefined
}

export function getTransferExtrasTotal(
  extras: Array<App.ExperienceTransferSelectedExtra> | undefined,
): number {
  return sum(getSelectedTransferExtras(extras) ?? [], extra => extra.price * extra.quantity)
}
